<template>
  <div class="vendor-signup-wrapper">
    <h5 data-test="vendorHomeHead"
								id="vendorHomeHead">Want to sell on Womenpower?</h5>
    <p data-test="vendorHomePara"
							id="vendorHomePara">List your products in less than 10 minutes!</p>
    <vendor-login-window-form @clientStatusResponse="verifyClientStatus($event)" />

    <!-- Login modal -->
    <vendor-login-modal :email="accountCreation.email" />
    <!-- Login modal -->
    <!-- Modal -->
    <vendor-sign-up-modal
      v-if="showSignUpForm"
      :vendorAccount="accountCreation"
      :from="from"
      :existingCustomerForm="existingCustomerForm"
      :email="accountCreation.email"
      @vendorSignUp="newVendorSignUp($event)"
      @existingCustomerVendorSignUp="existingCustomerSignUp($event)"
      @vendorSignUpModalClose="vendorSignUpModalClose"
    />
    <!-- Modal -->

    <!--&gt;existingCustomerModal-->
    <!--<existing-customer-modal :vendorAccount="accountCreation"-->
    <!--:fromData="from"-->
    <!--:email="accountCreation.email"-->
    <!--/>-->

    <!--<vendor-gst-modal>-->
    <!--</vendor-gst-modal>-->
  </div>
</template>

<script>
import vendorLoginModal from '@/components/pages/vendor/modals/vendorLoginModal'
import vendorLoginWindowForm from '@/components/pages/vendor/forms/VendorLoginWindowForm'
import vendorSignUpModal from '@/components/pages/vendor/modals/vendorSignUpModal'
import { vendorApis } from '@/services/ApiServices/vendorApis'
import { authenticationApi } from '@/services/ApiServices/authenticationApi'
import { globalApis } from '../../../services/ApiServices/globalApis'
// import VendorGstModal from '../vendorGstModal';
// import ExistingCustomerModal from '../existingCustomerModal';

export default {
	name: 'vendor-login-page',
	components: {
		// ExistingCustomerModal,
		// VendorGstModal,
		vendorLoginModal,
		vendorSignUpModal,
		vendorLoginWindowForm
	},
	data () {
		return {
			accountCreation: {
				email: ''
			},
			showSignUpForm: false,
			existingCustomerForm: false,
			from: ''
		}
	},
	methods: {
		async existingCustomerSignUp (vendorAdditionalInfo) {
			await vendorApis
				.newVendorLogin(vendorAdditionalInfo, 'existingCustomer')
				.then(() => {
					this.vendorSignUpModalClose()
				})
				.catch(e => {
					this.vendorSignUpModalClose()
				})
		},
		newVendorSignUp (vendorData) {
			vendorApis
				.vendorSignUp(vendorData)
				.then(res => {
					this.vendorSignUpModalClose()
				})
				.catch(e => {
					if (e.status === 412) {
						this.$toasted.show('You are already a vendor, Please login', {
							icon: 'exclamation-circle'
						})
						$('#LoginModal').modal('show')
					} else {
						this.$toasted.show(e.data.message, { icon: 'exclamation-circle' })
					}
				})
		},
		async verifyClientStatus (clientData) {
			this.accountCreation.email = clientData.email

			try {
				const userStatus = await authenticationApi.verifyClient(clientData)
				if (userStatus) {
					if (userStatus.vendor === false && userStatus.customer === false) {
						this.existingCustomerForm = false
						this.from = 'noVendorCustomer'
						this.showSignUpForm = true
						this.$nextTick(() => {
							$('#SignupModal').modal('show')
						})
					} else if (
						userStatus.vendor === false &&
            userStatus.customer === true
					) {
						this.existingCustomerForm = true
						this.from = 'noVendorCustomer'
						this.showSignUpForm = true
						this.$nextTick(() => {
							$('#SignupModal').modal('show')
						})
					} else {
						$('#LoginModal').modal('show')
					}
				}
			} catch (err) {}
		},
		vendorSignUpModalClose () {
			$('#SignupModal').modal('hide')
			this.showSignUpForm = false
		}
	},
	mounted () {
		globalApis.deliveryAddressCountryChooser()
	}
}
</script>

<style scoped>
</style>
